import { AccountService } from '@core/services';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, interval } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { GrupoModel, UtilizadorModel } from '@core/models';
import { ConfigService } from 'app/config.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class Helpers {
  userGroups: GrupoModel[];
  private authenticationChanged = new BehaviorSubject<boolean>(true);
  config = this.configService.getConfig();

  constructor(
    private configService: ConfigService,
    private jwt: JwtHelperService,
    private router: Router // private accountService: AccountService
  ) {
    /* this.isAuthenticationChanged().subscribe((x) => {
      if (!this.isAuthenticated())
        this.router.navigate(['/autenticacao/login']);
    }); */

    // this.getUserGroups();
  }

  public isAuthenticated(): boolean {
    return !(
      window.localStorage['token'] === undefined ||
      window.localStorage['token'] === null ||
      window.localStorage['token'] === 'null' ||
      window.localStorage['token'] === 'undefined' ||
      window.localStorage['token'] === ''
    );
  }

  public isAuthenticationChanged(): Observable<boolean> {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (
      window.localStorage['token'] === undefined ||
      window.localStorage['token'] === null ||
      window.localStorage['token'] === 'null' ||
      window.localStorage['token'] === 'undefined' ||
      window.localStorage['token'] === ''
    ) {
      return '';
    }
    let obj = JSON.parse(window.localStorage['token']);
    return obj;
  }

  public setToken(data: any): void {
    const token = JSON.stringify(data);
    this.setStorageToken(`${token}`);
  }

  public failToken(): void {
    this.setStorageToken(undefined);
  }

  public logout(): void {
    this.userGroups = undefined;
    this.setStorageToken(undefined);
    this.authenticationChanged.next(false);
    this.router.navigateByUrl('/autenticacao/login');
  }

  private setStorageToken(token: any): void {
    window.localStorage['token'] = token;
    this.authenticationChanged.next(this.isAuthenticated());
  }

  public getUserLogado(): UtilizadorModel {
    return this.jwt.decodeToken(JSON.stringify(window.localStorage['token']));
  }

  public isTokenExpired(token?: string): boolean {
    if (!token) token = this.getToken();
    if (!token) return true;
    return this.jwt.isTokenExpired(token);
  }

  public getTokenExpirationDate() {
    if (!this.isAuthenticated()) return undefined;
    return this.jwt.getTokenExpirationDate(this.getToken());
  }

  /* get hasRole() {
    return this.userGroups?.some(
      (x) => x.nome.toUpperCase() == 'ADMINISTRADORES'
    );
  } */

  generateApplicationHash(): string {
    const date = new Date();
    const create = date.setMinutes(date.getMinutes());
    const expire = date.setMinutes(date.getMinutes() + 120);

    var token = {
      data: '',
      createDate: new Date(create),
      expireDate: new Date(expire)
    }
    const password = this.config.hashKey;
    var iv = CryptoJS.enc.Utf8.parse(password);

    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(token)), password,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }

}
